export default {
  asearch: { id: "asearch" },
  ssearch: { id: "ssearch" },
  trackmetadata: { id: "trackmetadata" },
  albummetadata: { id: "albummetadata" },
  trackranking: { id: "trackranking" },
  albumranking: { id: "albumranking" },
};
